/**
 * @generated SignedSource<<fdbbd60ed2786c9a16f43f96bbe6ed9c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutGuestBuyerQueryRenderer_emailUser$data = {
  readonly " $fragmentSpreads": FragmentRefs<"checkoutRelayAction_emailUser">;
  readonly " $fragmentType": "CheckoutGuestBuyerQueryRenderer_emailUser";
};
export type CheckoutGuestBuyerQueryRenderer_emailUser$key = {
  readonly " $data"?: CheckoutGuestBuyerQueryRenderer_emailUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutGuestBuyerQueryRenderer_emailUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutGuestBuyerQueryRenderer_emailUser",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutRelayAction_emailUser",
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "checkoutShippingReducer_emailUser",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Profile",
              "kind": "LinkedField",
              "name": "profile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "email",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "29acc2061ef11b89ee93119654abca65";

export default node;
